import React, { useEffect, useMemo, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Badge,
  Alert
} from "reactstrap";
import Select from "react-select";
import moment from "moment";
import { calculateSummaryStats } from "../../utils/revenueCalculator";
// import { getAllEvents, getAllTicketBySlug, getAllVenueBySlug, getAllBookingByEvent, searchBookings, searchBookingsByContact, getAllBookingByDateRange, getReport } from "../../api/reportApi";  
import NormalTable from "../../components/common/Tables/NormalTable";
import FormattedDate from "../../components/common/DateFormat/FormattedDate";

// Date picker import (replace with your preferred date picker if needed)
import FlatPickr from "react-flatpickr";

interface Booking {
  bookingId: string;
  organizerId: string;
  [key: string]: any;
}

const RunReport: React.FC = () => {
const organizerData = localStorage.getItem("venueOrganizerData");
if (!organizerData) {
  throw new Error("Organizer data not found in localStorage");
}
const organizerId = JSON.parse(organizerData).organizerId;

  // State for search criteria
  const [searchCriteria, setSearchCriteria] = useState({
    fromDate: null as Date | null,
    toDate: null as Date | null,
    selectedEvent: null as any,
    selectedTicketType: null as any,
    selectedVenue: null as any,
    emailOrPhone: "",
    searchType: "date" // date, event, ticket, venue, email
  });

  // State for data
  const [eventList, setEventList] = useState<any[]>([]);
  const [venueList, setVenueList] = useState<any[]>([]);
  const [ticketTypeList, setTicketTypeList] = useState<any[]>([]);
  const [bookingList, setBookingList] = useState<Booking[]>([]);
  const [filteredBookingList, setFilteredBookingList] = useState<Booking[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // State for summary statistics
  const [summaryStats, setSummaryStats] = useState<any>({});

  // Available columns for selection
  const availableColumns = [
    { value: 'bookingNo', label: 'Booking No' },
    { value: 'name', label: 'Name' },
    { value: 'email', label: 'Email' },
    { value: 'phone', label: 'Phone' },
    { value: 'ticketType', label: 'Ticket Type' },
    { value: 'ticketCount', label: 'Ticket Count' },
    { value: 'ticketAmount', label: 'Ticket Amount' },
    { value: 'grandTotal', label: 'Grand Total' },
    { value: 'paymentStatus', label: 'Payment Status' },
    { value: 'bookingStatus', label: 'Booking Status' },
    { value: 'eventName', label: 'Event Name' },
    { value: 'venueName', label: 'Venue Name' },
    { value: 'createdAt', label: 'Created Date',}
  ];
  const [selectedColumns, setSelectedColumns] = useState<string[]>(availableColumns.map(col => col.value));

  // Fetch initial data (events)
  // useEffect(() => {
  //   async function fetchInitialData() {
  //     setLoading(true);
  //     try {
  //       const eventData = localStorage.getItem("eventData");
  //       if (eventData) {
  //         const eventSlug = JSON.parse(eventData).slugId;
  //         // const response = await getTicketTypeBySlug(eventSlug);
         
  //       }
  //       // Only fetch events for this organizer
  //       const eventsResp: any[] = await getAllEventByOrganizer();
  //       const eventOptions = eventsResp.map((item: any) => ({
  //           value: item.eventId,
  //           label: item.eventName,
  //           slugId: item.slugId
  //         }));
  //       setEventList(eventOptions);
  //     } catch (error) {
  //       setError("Failed to load events");
  //     } finally {
  //       setLoading(false);
  //     }
  //   }
  //   if (organizerId) fetchInitialData();
  // }, [organizerId]);

  // Handle event selection
  // const handleEventChange = async (selectedOption: any) => {
  //   setSearchCriteria(prev => ({ ...prev, selectedEvent: selectedOption }));
  //   if (selectedOption) {
  //     try {
  //       // Fetch venues and ticket types for the selected event
  //       const [venuesResp, ticketsResp] = await Promise.all([
  //         getAllVenueBySlug(selectedOption.slugId),
  //         getAllTicketBySlug(selectedOption.slugId)
  //       ]);
  //       const venueOptions = venuesResp.map((item: any) => ({
  //         value: item.venueId,
  //         label: item.venueName
  //       }));
  //       const ticketOptions = ticketsResp.map((item: any) => ({
  //         value: item.ticketTypeId,
  //         label: item.ticketType,
  //         price: item.price
  //       }));
  //       setVenueList(venueOptions);
  //       setTicketTypeList(ticketOptions);
  //     } catch (error) {
  //       setError("Failed to load event data");
  //     }
  //   } else {
  //     setVenueList([]);
  //     setTicketTypeList([]);
  //   }
  // };

  // Search bookings based on criteria (always filtered by organizerId)
  // const performBookingSearch = async () => {
  //   if (!organizerId) return;
  //   setLoading(true);
  //   setError("");
  //   let bookings: Booking[] = [];
  //   try {
  //     switch (searchCriteria.searchType) {
  //       case 'date':
  //         if (searchCriteria.fromDate && searchCriteria.toDate) {
  //           const response = await getAllBookingByDateRange(searchCriteria.fromDate, searchCriteria.toDate);
  //           bookings = response;
  //         }
  //         break;
  //       case 'event':
  //         if (searchCriteria.selectedEvent) {
  //           const response = await getReport(searchCriteria.selectedEvent.value);
  //           bookings = response;
  //         }
  //         break;
       
  //       case 'ticket':
  //         if (searchCriteria.selectedEvent && searchCriteria.selectedTicketType) {
  //           const response = await getReport(searchCriteria.selectedEvent.value);
  //           const filteredBookingByTicketType = response.filter((b: Booking) => Number(b.ticketTypeId) === Number(searchCriteria.selectedTicketType.value));
  //           bookings = filteredBookingByTicketType;
  //         }
  //         break;
  //       case 'venue':
  //         if (searchCriteria.selectedEvent && searchCriteria.selectedVenue) {
  //           const response = await searchBookings({
  //             eventId: searchCriteria.selectedEvent.value,
  //             venueId: searchCriteria.selectedVenue.value,
  //             organizerId
  //           });
  //           bookings = response;
  //         }
  //         break;
  //       case 'email':
  //         if (searchCriteria.emailOrPhone.trim()) {
  //           const response = await searchBookingsByContact(searchCriteria.emailOrPhone);
  //           if(response?.success){
  //             bookings = response?.data;
  //           }
  //         }
  //         break;
  //       default:
  //         break;
  //     }
  //     const filteredBookingByOrganizer = bookings.filter((b: Booking) => Number(b.organizerId) === Number(organizerId));
  //     setBookingList(filteredBookingByOrganizer);
  //     setFilteredBookingList(filteredBookingByOrganizer);
  //     setSummaryStats(calculateSummaryStats(filteredBookingByOrganizer));
  //   } catch (error) {
  //     setError("Failed to search bookings. Please try again.");
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  // Validate search criteria
  const isSearchValid = () => {
    switch (searchCriteria.searchType) {
      case 'date':
        return searchCriteria.fromDate && searchCriteria.toDate;
      case 'event':
        return searchCriteria.selectedEvent;
      case 'ticket':
        return searchCriteria.selectedEvent && searchCriteria.selectedTicketType;
      case 'venue':
        return searchCriteria.selectedEvent && searchCriteria.selectedVenue;
      case 'email':
        return searchCriteria.emailOrPhone.trim().length > 0;
      default:
        return false;
    }
  };

  // Handle column selection
  const handleColumnSelection = (selectedOptions: any) => {
    const selectedValues = selectedOptions.map((option: any) => option.value);
    setSelectedColumns(selectedValues);
  };

  // Transform booking data for NormalTable
  const transformedData = useMemo(() => {
    return filteredBookingList.map((booking) => {
      // Extract contact details from bookingObject
      const contactDetails = booking.bookingObject?.primaryContactDetails || {};
      const attendees = booking.bookingObject?.attendees || [];
      
      return {
        id: booking.bookingId,
        bookingId: booking.bookingId,
        bookingNo: booking.bookingNo,
        name: `${contactDetails.firstName || ''} ${contactDetails.lastName || ''}`.trim() || 'N/A',
        email: contactDetails.email || 'N/A',
        phone: contactDetails.phoneNo || 'N/A',
        ticketType: booking.TicketType?.ticketType || 'N/A',
        ticketCount: booking.totalTicketCount || 0,
        ticketAmount: booking.totalTicketAmount || 0,
        grandTotal: booking.grandTotal || 0,
        paymentStatus: booking.paymentStatus || 'N/A',
        bookingStatus: booking.bookingStatus || 'N/A',
        eventName: booking.Event?.eventName || 'N/A',
        venueName: booking.Venue?.venueName || 'N/A',
        createdAt: booking.createdAt ? <FormattedDate dateString={booking.createdAt} /> : 'N/A',
        // Keep original booking object for custom cell content
        originalBooking: booking
      };
    });
  }, [filteredBookingList]);

  // Create NormalTable columns
  const tableColumns = useMemo(() => {
    const baseColumns = [
      { key: 'bookingNo', label: 'Booking No', width: 180 },
      { key: 'name', label: 'Name', width: 150 },
      { key: 'email', label: 'Email', width: 200 },
      { key: 'phone', label: 'Phone', width: 120 },
      { key: 'ticketType', label: 'Ticket Type', width: 150 },
      { key: 'ticketCount', label: 'Ticket Count', width: 120 },
      { key: 'ticketAmount', label: 'Ticket Amount', width: 130 },
      { key: 'grandTotal', label: 'Grand Total', width: 130 },
      { key: 'paymentStatus', label: 'Payment Status', width: 130 },
      { key: 'bookingStatus', label: 'Booking Status', width: 130 },
      { key: 'eventName', label: 'Event Name', width: 200 },
      { key: 'venueName', label: 'Venue Name', width: 150 },
      { key: 'createdAt', label: 'Created Date', width: 150 }
    ];

    // Filter columns based on selected columns
    return baseColumns.filter(col => selectedColumns.includes(col.key));
  }, [selectedColumns]);

  // Custom cell content for specific fields
  const getCellContent = (field: string) => (row: any) => {
    switch (field) {
      case 'paymentStatus':
        const paymentStatus = row.paymentStatus;
        const paymentColor = paymentStatus === 'paid' ? 'success' : paymentStatus === 'pending' ? 'warning' : 'danger';
        return <Badge color={paymentColor}>{paymentStatus?.toUpperCase()}</Badge>;
      
      case 'bookingStatus':
        const bookingStatus = row.bookingStatus;
        const bookingColor = bookingStatus === 'confirmed' ? 'success' : bookingStatus === 'pending' ? 'warning' : 'danger';
        return <Badge color={bookingColor}>{bookingStatus?.toUpperCase()}</Badge>;
      
      case 'grandTotal':
        return <span className="fw-bold">${row.grandTotal?.toFixed(2) || '0.00'}</span>;
      
      case 'ticketAmount':
        return <span>${row.ticketAmount?.toFixed(2) || '0.00'}</span>;
      
      default:
        return row[field] || 'N/A';
    }
  };

  // Add cell content to columns
  const finalTableColumns = useMemo(() => {
    return tableColumns.map(col => ({
      ...col,
      cellContent: getCellContent(col.key)
    }));
  }, [tableColumns]);

  const customStyles = {
    option: (provided: any, state: any) => ({
      ...provided,
      backgroundColor: state.isSelected ? '#007bff' : state.isFocused ? '#f8f9fa' : 'white',
      color: 'black',
      cursor: 'pointer'
    }),
    control: (provided: any) => ({
      ...provided,
      backgroundColor: '#343a40',
      borderColor: '#495057'
    }),
    menu: (provided: any) => ({
      ...provided,
      backgroundColor: 'white',
      border: '1px solid #dee2e6'
    }),
    singleValue: (provided: any) => ({
      ...provided,
      color: 'white'
    }),
    input: (provided: any) => ({
      ...provided,
      color: 'white'
    })
  }
  ;
  return (
    <div className="page-content">
      <Container fluid>
        <Card className="bg-dark text-white">
          <CardBody>
            <h4 className="card-title mb-4">Run Report (Auto-filtered by Organizer)</h4>
            <Form>
              <Row>
                {/* Search Type Selection */}
                <Col lg={3} md={6}>
                  <FormGroup>
                    <Label>Search Type</Label>
                    <Select
                      value={{
                        value: searchCriteria.searchType,
                        label: searchCriteria.searchType.charAt(0).toUpperCase() + searchCriteria.searchType.slice(1)
                      }}
                      onChange={(option: any) => setSearchCriteria(prev => ({
                        ...prev,
                        searchType: option.value,
                        selectedEvent: null,
                        selectedTicketType: null,
                        selectedVenue: null,
                        emailOrPhone: ""
                      }))}
                      options={[
                        { value: 'date', label: 'Date Range' },
                        { value: 'event', label: 'Event' },
                        { value: 'ticket', label: 'Ticket Type' },
                        { value: 'venue', label: 'Venue' },
                        { value: 'email', label: 'Email/Phone' }
                      ]}
                      placeholder="Select search type"
                      className="bg-dark text-white"
                      styles={customStyles}
                    />
                  </FormGroup>
                </Col>
                {/* Date Range */}
                {searchCriteria.searchType === 'date' && (
                  <>
                    <Col lg={3} md={6}>
                      <FormGroup>
                        <Label>From Date</Label>
                        <FlatPickr
                           className="form-control"
                           placeholder="Select from date"
                          value={searchCriteria.fromDate || ''}
                          onChange={(e: any) => setSearchCriteria(prev => ({ ...prev, fromDate: e }))}
                         
                        />
                      </FormGroup>
                    </Col>
                    <Col lg={3} md={6}>
                      <FormGroup>
                        <Label>To Date</Label>
                        <FlatPickr
                         className="form-control"
                         placeholder="Select to date"
                        
                          value={searchCriteria.toDate || ''}
                          onChange={(e: any) => setSearchCriteria(prev => ({ ...prev, toDate: e }))}
                         
                        />
                      </FormGroup>
                    </Col>
                  </>
                )}
                {/* Event Selection */}
                {(searchCriteria.searchType === 'event' || searchCriteria.searchType === 'ticket' || searchCriteria.searchType === 'venue') && (
                  <Col lg={3} md={6}>
                    <FormGroup>
                      <Label>Event</Label>
                      <Select
                        value={searchCriteria.selectedEvent}
                        // onChange={handleEventChange}
                        options={eventList}
                        placeholder="Select event"
                        isClearable
                        styles={customStyles}
                      />
                    </FormGroup>
                  </Col>
                )}
                {/* Ticket Type Selection */}
                {searchCriteria.searchType === 'ticket' && (
                  <Col lg={3} md={6}>
                    <FormGroup>
                      <Label>Ticket Type</Label>
                      <Select
                        value={searchCriteria.selectedTicketType}
                        onChange={(option: any) => setSearchCriteria(prev => ({ ...prev, selectedTicketType: option }))}
                        options={ticketTypeList}
                        placeholder="Select ticket type"
                        isClearable
                        styles={customStyles}
                      />
                    </FormGroup>
                  </Col>
                )}
                {/* Venue Selection */}
                {searchCriteria.searchType === 'venue' && (
                  <Col lg={3} md={6}>
                    <FormGroup>
                      <Label>Venue</Label>
                      <Select
                        value={searchCriteria.selectedVenue}
                        onChange={(option: any) => setSearchCriteria(prev => ({ ...prev, selectedVenue: option }))}
                        options={venueList}
                        placeholder="Select venue"
                        isClearable
                        styles={customStyles}
                      />
                    </FormGroup>
                  </Col>
                )}
                {/* Email/Phone Search */}
                {searchCriteria.searchType === 'email' && (
                  <Col lg={3} md={6}>
                    <FormGroup>
                      <Label>Email or Phone</Label>
                      <Input
                        type="text"
                        value={searchCriteria.emailOrPhone}
                        onChange={(e) => setSearchCriteria(prev => ({ ...prev, emailOrPhone: e.target.value }))}
                        placeholder="Enter email or phone number"
                      />
                    </FormGroup>
                  </Col>
                )}
              </Row>
              <Row className="align-items-center">
                {/* Search Button */}
                <Col lg={2} md={6} className="d-flex align-items-end">
                  <Button
                    color="primary"
                    // onClick={performBookingSearch}
                    disabled={loading || !isSearchValid()}
                    className="w-100"
                  >
                    {loading ? 'Searching...' : 'Search'}
                  </Button>
                </Col>
                <Col lg={1} md={6} className="d-flex align-items-end">
                  <Button
                    color="secondary"
                    onClick={() => {
                      setSearchCriteria({
                        fromDate: null,
                        toDate: null,
                        selectedEvent: null,
                        selectedTicketType: null,
                        selectedVenue: null,
                        emailOrPhone: "",
                        searchType: "date"
                      });
                      setFilteredBookingList([]);
                      setBookingList([]);
                      setError("");
                    }}
                    className="w-100"
                  >
                    Clear
                  </Button>
                </Col>
              </Row>
            </Form>
            {/* Results Section */}
            {filteredBookingList.length > 0 && (
              <>
                {/* Summary Statistics */}
                <Card className="mb-3 mt-4">
                  <CardBody>
                    <h5 className="card-title mb-4">
                      <i className="bx bx-bar-chart-alt-2 me-2 text-primary"></i>
                      Summary Statistics
                    </h5>
                    <Row>
                      <Col lg={3} md={6} className="mb-3">
                        <div className="border rounded p-3 text-center h-100">
                          <div className="text-primary mb-2">
                            <i className="bx bx-calendar-check fs-2"></i>
                          </div>
                          <h4 className="mb-1 fw-bold">{summaryStats?.totalBookings || 0}</h4>
                          <p className="text-muted mb-0">Total Bookings</p>
                        </div>
                      </Col>
                      <Col lg={3} md={6} className="mb-3">
                        <div className="border rounded p-3 text-center h-100">
                          <div className="text-success mb-2">
                            <i className="bx bx-dollar-circle fs-2"></i>
                          </div>
                          <h4 className="mb-1 fw-bold">${summaryStats?.totalRevenue?.toFixed(2) || '0.00'}</h4>
                          <p className="text-muted mb-0">Total Revenue</p>
                        </div>
                      </Col>
                      <Col lg={3} md={6} className="mb-3">
                        <div className="border rounded p-3 text-center h-100">
                          <div className="text-info mb-2">
                            <i className="bx bx-tickets fs-2"></i>
                          </div>
                          <h4 className="mb-1 fw-bold">{summaryStats?.totalTickets || 0}</h4>
                          <p className="text-muted mb-0">Total Tickets</p>
                        </div>
                      </Col>
                      <Col lg={3} md={6} className="mb-3">
                        <div className="border rounded p-3 text-center h-100">
                          <div className="text-warning mb-2">
                            <i className="bx bx-discount fs-2"></i>
                          </div>
                          <h4 className="mb-1 fw-bold">${summaryStats?.totalDiscount?.toFixed(2) || '0.00'}</h4>
                          <p className="text-muted mb-0">Total Discount</p>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
                {/* Results Table */}
                <Card>
                  <CardBody>
                    <Row className="mb-3">
                      <Col lg={6}>
                        <h4 className="card-title">Search Results</h4>
                        <p className="text-muted">
                          Found {filteredBookingList.length} booking(s)
                        </p>
                      </Col>
                      <Col lg={6} className="text-end">
                        {/* Export buttons can be added here */}
                      </Col>
                    </Row>
                    {/* Column Selection */}
                    <Row className="mb-3">
                      <Col lg={8}>
                        <FormGroup>
                          <Label>Select Columns to Display</Label>
                          <Select
                            isMulti
                            value={availableColumns.filter(col => selectedColumns.includes(col.value))}
                            onChange={handleColumnSelection}
                            options={availableColumns}
                            placeholder="Select columns to display"
                            styles={{
                              control: (base) => ({
                                ...base,
                                backgroundColor: 'transparent',
                                color: 'black'
                              })
                            }}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    {/* NormalTable Component */}
                    <NormalTable
                      columns={finalTableColumns}
                      data={transformedData}
                      getRowId={(row:any) => row.bookingId}
                    />
                  </CardBody>
                </Card>
              </>
            )}
            {/* Error Message */}
            {error && (
              <Alert color="danger" className="mt-3">
                {error}
              </Alert>
            )}
            {/* No Results Message */}
            {!loading && filteredBookingList.length === 0 && bookingList.length > 0 && (
              <Alert color="info" className="mt-3">
                No bookings found matching your search criteria.
              </Alert>
            )}
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default RunReport;